export * from './lib/ui-confirm-dialog.module';
export * from './lib/confirm-dialog/confirm-dialog.component';
